jQuery(function() {
  
 var mytea = jQuery(".mixer-cart").children(".cart").children("ul").children("li").hasClass("tea-add");

   if (mytea) {
     jQuery(".mix-add-cart ").show();
    jQuery(".no-tea-select").hide();
   }
     else{
      jQuery(".mix-add-cart ").hide();
       jQuery(".no-tea-select").show();
     }
   
  jQuery(".no-tea-select").click(function(){
     jQuery(".mixer-sidebar").children("ul").find(".tea").trigger('click');
     });
  
  
  
  jQuery(".item-qty-box .qtyminus").click(function() {
     var zero =  jQuery(this).next(".quantity").val(); 
    var itemzero = jQuery(this).parents(".item-qty-box").prev(".item-remove").children(".btn").attr('href');
   // alert(itemzero);
    if(zero <= 1){
      window.location.href = itemzero;
     jQuery(this).parents(".item-qty-box").prev(".item-remove").children(".btn").addClass('remove');
       
   }
   else {
    }
    });
 
  
  /* Total Price increament according quantity */
 
   jQuery('.qtyplus').click(function(){
      var basePrice = parseFloat(jQuery(this).parents('.item-qty-box').next('.item-price').find('.base-money').text().replace(/,/g, '.'));
     
     var qty = jQuery(this).siblings('.quantity').val();
     var num = 1;
     var qtyup =  parseFloat(qty) + parseFloat(num);
     
     var basePriceup = parseFloat(basePrice*qtyup); //Calculating price for quantites selected
     
     var basePricenew = basePriceup.toFixed(2); //Converting to decimal
     jQuery(this).parents('.item-qty-box').next('.item-price').find('.moneyy').html(basePricenew);
     
     var grandtotal1 = 0;
     jQuery('.cart ul li').each(function(){
       
     var total = 0;
      
     var totalabc =  parseFloat(jQuery(this).children('.mix_crts').children('.mix-crt-dtl').children('.item-price').children('.moneyy').text().replace(/,/g, '.'));
  
      var grandtotal =  parseFloat(totalabc) + parseFloat(total);
       
      grandtotal1 = parseFloat(grandtotal1) + parseFloat(grandtotal);
      grandtotal1 = grandtotal1.toFixed(2);
       
      });
    
     // console.log(grandtotal1);
      jQuery('.mix-total').children('.cart__subtotal').find('.money').html('€'+grandtotal1+' EUR');
     
   });
  
  
  
  // var basePricemin = parseFloat(jQuery(this).parents('.item-qty-box').next('.item-price').find('.base-money').text().replace(/,/g, '.'));
     jQuery('.qtyminus').click(function(){
      var basePricemin = parseFloat(jQuery(this).parents('.item-qty-box').next('.item-price').find('.base-money').text().replace(/,/g, '.'));
      console.log(basePricemin);
     var qtymin = jQuery(this).siblings('.quantity').val();
       console.log(qtymin);
     var nummin = 1;
     var qtyupmin =  parseFloat(qtymin) - parseFloat(nummin);
     console.log(qtyupmin);
       
     var basePriceupmin = parseFloat(basePricemin*qtyupmin); //Calculating price for quantites selected
     console.log(basePriceupmin);
       
     var basePricenewmin = basePriceupmin.toFixed(2); //Converting to decimal
       console.log(basePricenewmin);
     jQuery(this).parents('.item-qty-box').next('.item-price').find('.moneyy').html(basePricenewmin);
     
     var grandtotal1min = 0;
     jQuery('.cart ul li').each(function(){
       
     var totalmin = 0;
      
     var totalabcmin =  parseFloat(jQuery(this).children('.mix_crts').children('.mix-crt-dtl').children('.item-price').children('.moneyy').text().replace(/,/g, '.'));
  
      var grandtotalmin =  parseFloat(totalabcmin) + parseFloat(totalmin);
       
      grandtotal1min = parseFloat(grandtotalmin) + parseFloat(grandtotal1min);
      grandtotal1min = grandtotal1min.toFixed(2);
       
      });
    
      console.log(grandtotal1min);
      jQuery('.mix-total').children('.cart__subtotal').find('.money').html('€'+grandtotal1min+' EUR');
       
 
   });
  
  /* Total Price increament according quantity */
  
  
      jQuery(".category-title").click(function(){
        jQuery(this).next("ul").slideToggle();
    });
     jQuery(".filter_btn").click(function(){
       jQuery(this).next(".sidebar-left").slideToggle();
       jQuery(this).next(".blog-sidebar").slideToggle();
       
    });
    jQuery(".site-header__cart").click(function(){
       jQuery(".shopping-cart-dropdown").slideToggle();
     
    });
  
}); 

jQuery(function() {
  
  jQuery(".grid-icon").click(function(){
    jQuery(this).addClass('active');
    jQuery(".list-icon").removeClass('active');
    jQuery('.grid-view').show();   
    jQuery('.list-view').hide();     
  });
  
  jQuery(".list-icon").click(function(){
    jQuery(this).addClass('active');
    jQuery(".grid-icon").removeClass('active');
    jQuery('.grid-view').hide();   
    jQuery('.list-view').show();     
  });
  
}); 



jQuery(function() {
  
  
  /*  jQuery(".tea").click(function(){
    jQuery('#tea').addClass('active');
    jQuery("#tea").siblings('.featured_pro_inner').removeClass('active');
    jQuery('#tea').show();   
    jQuery('#tea').siblings('.featured_pro_inner').hide();     
  });
  
   jQuery(".flowers").click(function(){
    jQuery('#flowers').addClass('active');
    jQuery("#flowers").siblings('.featured_pro_inner').removeClass('active');
    jQuery('#flowers').show();   
    jQuery('#flowers').siblings('.featured_pro_inner').hide();     
  });
  
  
   jQuery(".fruits").click(function(){
    jQuery('#fruits').addClass('active');
    jQuery("#fruits").siblings('.featured_pro_inner').removeClass('active');
    jQuery('#fruits').show();   
    jQuery('#fruits').siblings('.featured_pro_inner').hide();     
  });   */
  
  
  jQuery(document).on('click','.mixer-sidebar ul .tea-sel',(function(){
    jQuery(this).addClass('active');
    jQuery(this).siblings('li').removeClass('active');
    jQuery('.featured_pro_inner').hide();
    jQuery('.featured_pro_inner').removeClass('active');
  	var items = jQuery(this).attr('data-id');
    jQuery("#" + items).show();
    jQuery("#" + items).addClass('active');
 
    
  }));  
  
  jQuery(".no-base").click(function() {
  jQuery(".cart--empty-message").css("color","red");
   });
  
  
  
  
 
});



jQuery(document).ready(function(){
    // This button will increment the value
    jQuery('.qtyplus').click(function(e){
      
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = jQuery(this).attr('field');
      
        // Get its current value
        var currentVal = parseInt(jQuery(this).prev('input[id='+fieldName+']').val());
     
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            jQuery(this).prev('input[id='+fieldName+']').val(currentVal + 1);
          
        } else {
            // Otherwise put a 0 there
            jQuery(this).prev('input[id='+fieldName+']').val(0);
          
        }
    });
    // This button will decrement the value till 0
    jQuery(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = jQuery(this).attr('field');
        // Get its current value
        var currentVal = parseInt(jQuery(this).next('input[id='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            jQuery(this).next('input[id='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            jQuery(this).next('input[id='+fieldName+']').val(0);
        }
    });
  
  if (localStorage.getItem("product") != null) {
     $('.no-base').each(function(){
        	str = $(this).text();
      		$(this).addClass('tea-sel').attr('data-id',str.toLowerCase()).removeClass('no-base');
      })
  }
});


$(function() {
 
    jQuery.ajax({
        type: 'GET',
        url: 'https://wetfins-dev.myshopify.com/cart.json',
        dataType: 'jsonp',
        success: function(data) { 
            var item_count = data['item_count'];
            var total_price = data['total_price']/100;

            //If there are items in cart
            if ( item_count > 0 ) {
                // cart count
                jQuery('.cart-count').text(item_count);

                // mini cart data
                jQuery('.mini-cart').attr('id','mini-cart');
                jQuery('.mini-cart-subtotal .price').text( '$' + total_price.toFixed(2) );

                var cart_list = [];
           
                for( var i = 0; i < item_count; i++ ){
                    if ( data['items'][i]['id'] != null ) {
                        var item_id = data['items'][i]['id'];
                        var product_title = data['items'][i]['product_title'];
                        // var product_title = data['items'][i]['title'];
                        var product_handle = data['items'][i]['handle'];
                        var quantity = data['items'][i]['quantity'];
                        var line_price = data['items'][i]['price']/100;
                        var url = data['items'][i]['url'];
                        var image_url = data['items'][i]['image'];
                        var variants = data['items'][i]['variant_options'];
                           
                        if ( product_title == 'Pilot Fins' ) {
                            var product_url = product_title;
                        } else {
                            var product_url = '<a href="https://wetfins-dev.myshopify.com' + url + '">' + product_title + '</a>';
                        }

                        var options = [];
                        for ( var o = 0; o < variants.length; o++ ) {
                            var selected = data['items'][i]['variant_options'][o];
                            if ( selected !== 'Default Title' ) {
                                options.push( selected + '' );
                            }
                        }
                        var selected_options = options.join('');

                        cart_list.push('<div class="mini-cart-product"><div class="col span_3 mini-image"><div class="product_image"><img src="' + image_url + '"  alt="' + product_title + '" /></div></div><div class="col span_6">' + product_url + '<div class="custom_optn">' + selected_options + '</div></div><div class="col span_6 text-left pull-right">$'+ line_price.toFixed(2) +'x ' + quantity + '<input type="hidden" id="updates_' + item_id + '" value="' + quantity + '" /></div></div>');
                    } //endif
                } // endfor

                jQuery('.mini-cart-items').append( cart_list.join('') );
            }
        }
    });

 });

 

 function addTocart(e){
   var flowers = localStorage.getItem("flowers");
    if (flowers) {
        flowers = JSON.parse(flowers);
    }else{
    	flowers = [];
    }
   	
   var prId = $(e).data('id');
   var sideActive = $('.mixer-sidebar .active').attr('data-id');
   if(sideActive == 'tea'){ 
     localStorage.setItem("product", prId);
   }else if(sideActive == 'flowers'){
     flowers.push(prId);
     localStorage.setItem("flowers", JSON.stringify(flowers));
   }
  	
 
 	
     if (localStorage.getItem("product") != null) {   		
       $('.no-base').each(function(){
              str = $(this).text();
              $(this).addClass('tea-sel').attr('data-id',str.toLowerCase()).removeClass('no-base');
        })
     }
  	$('empty-mini-cart').hide();
   
   

   //document.getElementById("demo").innerHTML = ' {{ product.title }} , <img src="{{ product | img_url }}"> , {{ product.price }} ';
    	

    }
  